import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IStripeChargeInfo } from "../../api/stripe/index.types";

export interface Payment {
  account: {
    name: string;
    id: number;
    email: string;
  };
  accounts_id: number;
  id: number;
  plan: {
    name: string;
  };
  price_usd: number;
  status: string;
  purchase_date: string;
  stripe_ch: string;
}

export interface IPaymentsStatus {
  payments: Payment[];
  retrievedCharges: IStripeChargeInfo[];
  count: number;
  loading: boolean;
}

export interface FeedState {
  data: {
    failedPayments: IPaymentsStatus;
  };
}

const initialState: FeedState = {
  data: {
    failedPayments: {
      payments: [],
      retrievedCharges: [],
      count: 0,
      loading: false,
    },
  },
};

const index = createSlice({
  name: "feed",
  initialState,
  reducers: {
    fetchFailedPaymentsRequest: (state) => {
      state.data.failedPayments.loading = true;
    },
    fetchFailedPaymentsSuccess: (
      state,
      action: PayloadAction<{
        payments: Payment[];
        retrievedCharges: IStripeChargeInfo[];
        count: number;
      }>
    ) => {
      state.data.failedPayments.loading = false;
      state.data.failedPayments.payments = action.payload.payments;
      state.data.failedPayments.retrievedCharges = action.payload.retrievedCharges;
      state.data.failedPayments.count = action.payload.count;
    },
    fetchFailedPaymentsFailed: (state) => {
      state.data.failedPayments.loading = false;
    },
  },
});

export const feedActions = index.actions;
export default index.reducer;
